export const invoiceReIssueTags = ['ReIssueAirTicket'];
export const RE_ISSUE_AIRTICKET_ID = 'RE_ISSUE_AIRTICKET';
